import { Injectable } from '@angular/core';
import { IAutoCompleteItem } from 'auto-complete-lib';
import { Observable, of } from 'rxjs';
import { IFieldMeta } from '../../interfaces/imetadata';
import { FieldType } from '../../utils/fieldtype';
import { templateContext } from '../../utils/template-context';

@Injectable({
  providedIn: 'root',
})
export class AutoCompleteDefaultService {
  private allLeafFields: IFieldMeta[] = [];

  constructor() {
    // we don't need the "parent" fields because they'll be included with the leaf child fields
    this.allLeafFields = templateContext.getFlatList().filter((f) => !this.isContainerField(f.type));
  }

  queryFn(filterValue: string): Observable<IAutoCompleteItem<any>[]> {
    console.log('filter by:', filterValue);

    const items: IAutoCompleteItem<IFieldMeta>[] = [];
    const uniqueValues = new Set();
    this.allLeafFields.forEach((f) => {
      if (!f.path.toLowerCase().startsWith(filterValue.toLowerCase())) {
        return;
      }

      const previousDotIndex = f.path.lastIndexOf('.', filterValue.length);
      let nextDotIndex = f.path.indexOf('.', filterValue.length);
      if (nextDotIndex < 0) {
        nextDotIndex = f.path.length - 1;
      }
      const value = f.path.substring(previousDotIndex + 1, nextDotIndex + 1);
      if (!uniqueValues.has(value)) {
        uniqueValues.add(value);
        items.push({ label: value, data: f });
      }
    });

    console.log('return', items);

    return of(items);
  }

  tabHandlerFn(input: string, item: IAutoCompleteItem<any> | undefined): string | undefined {
    if (!item) {
      return undefined;
    }

    const dotIndex = input.lastIndexOf('.');
    const head = input.substring(0, dotIndex + 1);
    const tail = item.label;
    return `${head}${tail}`;
  }

  private isContainerField(type: string): boolean {
    return type === FieldType.TO_MANY || type === FieldType.TO_ONE || type === FieldType.COMPOSITE;
  }
}
